import React from 'react';
import PropTypes from 'prop-types';

const AnimatedClock = ({ seconds }) => {
    const secAngle = ((60 - seconds) % 60) * 6;

  return (
    <svg width={54} height={54} viewBox="0 0 64 64">
      <circle cx="32" cy="32" r="25" fill="url(#clockGradient)" stroke="#0154D2" strokeWidth="3" />
      <line
        x1="32"
        y1="32"
        x2={32 + 17 * Math.sin((Math.PI / 180) * secAngle)}
        y2={32 - 17 * Math.cos((Math.PI / 180) * secAngle)}
        stroke="#0154D2"
        strokeWidth="3"
        strokeLinecap="round"
      />
      <circle cx="32" cy="32" r="3.5" fill="#fff" stroke="#0154D2" strokeWidth="1.5" />
      <defs>
        <radialGradient id="clockGradient" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#e3f0ff" />
          <stop offset="100%" stopColor="#b5d7fc" />
        </radialGradient>
      </defs>
    </svg>
  );

};

AnimatedClock.propTypes = {
  seconds: PropTypes.number.isRequired,
};

export default AnimatedClock;
